
import React from "react";
import FlowCalculatorSteps from "./FlowCalculatorSteps";

interface FlowCalculatorCardProps {
  method: "classic" | "yolo";
}

const FlowCalculatorCard = ({ method }: FlowCalculatorCardProps) => {
  return (
    <div className="space-y-6">
      <FlowCalculatorSteps method={method} />
    </div>
  );
};

export default FlowCalculatorCard;
